$(document).ready(function(){  
    
	$(document).on('click', '.add-to-cart', function() {
      return false;
      var currency = $('.currency-picker').val();  
      
      var form_data = this.id;
      console.log(form_data);
      
      $.ajax({
          url: '/cart/add',
          type: 'post',
          data: $('#'+form_data).serialize(),
          success: function(response) {
            
            $('#cart-target').addClass('has-items');
            
              $.ajax({
                url: '/cart.js',
                type: 'GET',
                dataType: 'json',
                success: function(cartdata) {             

                    //console.log(cartdata.item_count);


                    $('#addToSuccess').show().fadeIn(50).fadeOut(3000);
                    $('#cart-count').text(cartdata.item_count);

                    var p = (cartdata['items'][0].price)/100;
                    var price = p.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    var line_price = cartdata['items'][0].line_price;

                    if(cartdata.item_count > 1){

                      var count = 0;

                        $(document).on('each','.remove_item',function(){
                          var data_id = $(this).attr('data-id');    

                          if(data_id == cartdata['items'][0].id){                      
                            count = 1;

                              //console.log($(this).parents().parents().siblings('.product_details_bottom').children('.price').children());
                              //console.log($(this).parents().parents().siblings('.product_details_bottom').children('strong'));

                              //$(this).parents().parents().siblings('.product_details_bottom').children('.price').children().text(price);
                              $(this).parents().parents().siblings('.product_details_bottom').children('strong').text(cartdata['items'][0].quantity);

                              $('.currency-picker option[value="'+currency+'"]').attr('selected','selected');
                              $('.currency-picker').trigger('change');


                          }
                          else if(count == 0){
                            count = 1;
                               var ul = '<li class="item  last">'+
                                  '<div class="item_inner"> '+
                                    '<a class="product_image" href="'+cartdata['items'][0].url+'" title="">'+
                                      '<img width="70" height="80" src="'+cartdata['items'][0].image+'"  alt="'+cartdata['items'][0].product_title+'">'+
                                      '</a>'+
                                    '<div class="detail_item">'+
                                      '<div class="product_details">'+
                                        '<p class="product_name"><a href="'+cartdata['items'][0].url+'">'+cartdata['items'][0].product_title+'</a></p>'+
                                        '<div class="access"> <a class="btn_remove1 remove_item" href="" data-id="'+cartdata['items'][0].id+'"><span class="icon"></span>X</a> </div>'+                              
                                      '</div>'+
                                      '<div class="product_details_bottom">'+
                                          '<span class="price">'+
                                              '<span class="money">'+price+'</span>'+
                                          '</span>'+
                                          '<span class="title_desc">Qty:</span>'+
                                          '<strong>'+cartdata['items'][0].quantity+'</strong>'+ 
                                      '</div>'+                            
                                    '</div>'+
                                  '</div>'+
                                '</li>';

                              //ul.appendTo( $( ".minicart_content" ) );        
                            $('.mini_products_list li:eq(0)').before(ul);
                            
                            $('.currency-picker option[value="'+currency+'"]').attr('selected','selected');
                            $('.currency-picker').trigger('change');

                          }            

                      });
                    }
                    else{
                          var ul = $('<ul class="mini_products_list" id="cart-sidebar"><li class="item  last">'+
                                  '<div class="item_inner"> '+
                                    '<a class="product_image" href="'+cartdata['items'][0].url+'" title="">'+
                                      '<img width="70" height="80" src="'+cartdata['items'][0].image+'"  alt="'+cartdata['items'][0].product_title+'">'+
                                      '</a>'+
                                    '<div class="detail_item">'+
                                      '<div class="product_details">'+
                                        '<p class="product_name"><a href="'+cartdata['items'][0].url+'">'+cartdata['items'][0].product_title+'</a></p>'+
                                        '<div class="access"> <a class="btn_remove1 remove_item" href="" data-id="'+cartdata['items'][0].id+'"><span class="icon"></span>X</a> </div>'+                              
                                      '</div>'+
                                      '<div class="product_details_bottom">'+
                                          '<span class="price">'+
                                              '<span class="money">'+price+'</span>'+
                                          '</span>'+
                                          '<span class="title_desc">Qty:</span>'+
                                          '<strong>'+cartdata['items'][0].quantity+'</strong>'+ 
                                      '</div>'+                            
                                    '</div>'+
                                  '</div>'+
                                '</li><ul>');
                          ul.appendTo( $( ".minicart_content" ) );

                      $('.currency-picker option[value="'+currency+'"]').attr('selected','selected');
                      $('.currency-picker').trigger('change');


                    }



                    $('.top_subtotal').children('.subtotal').remove();
                      var subtotal = $('<span class="subtotal">'+
                                          '<span class="money">'+line_price+'</span>'+
                                       '</span>');
                      subtotal.appendTo($('.top_subtotal'));  

                    $('.currency-picker option[value="'+currency+'"]').attr('selected','selected');              
                    $('.currency-picker').trigger('change');

                 }
            });  
          }
      });
	});

 
  
  
  
});

	